import styled from "styled-components";

/** Valut charcoal tooltip — not white-label navy `theme.primary.dark` (#003967). */
const VALUT_TOOLTIP_BG = "#1a1a1a";
const VALUT_TOOLTIP_FG = "#f8f3ed";
const VALUT_TOOLTIP_BORDER = "rgba(231, 167, 63, 0.35)";

export const Container = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  > .tooltip-bubble {
    width: max-content;
    max-width: 400px;
    display: inline-block;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    opacity: 0;
    visibility: hidden;
    background-color: ${VALUT_TOOLTIP_BG};
    border: 1px solid ${VALUT_TOOLTIP_BORDER};
    transition: opacity 0.4s;
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translate(-50%);
    color: ${VALUT_TOOLTIP_FG};
    z-index: 2000;
    white-space: normal;
    word-break: break-word;
    text-align: left;
    pointer-events: none;

    &::before {
      content: "";
      border-style: solid;
      border-color: ${VALUT_TOOLTIP_BG} transparent transparent transparent;
      border-width: 6px 6px 0 6px;
      top: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &.tight > .tooltip-bubble {
    bottom: calc(100% - 12px);
  }
  &&:hover > .tooltip-bubble, &:focus-within > .tooltip-bubble {
    opacity: 1;
    visibility: visible;
  }
`;

export const Bubble = styled.div`
  position: fixed;
  transform: translate(-50%, calc(-100% - 8px));
  width: max-content;
  max-width: 400px;
  display: inline-block;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
  opacity: 1;
  visibility: visible;
  background-color: ${VALUT_TOOLTIP_BG};
  border: 1px solid ${VALUT_TOOLTIP_BORDER};
  color: ${VALUT_TOOLTIP_FG};
  z-index: 10000;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  pointer-events: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
  transition: opacity 140ms ease-out, transform 140ms ease-out;

  &::before {
    content: "";
    border-style: solid;
    border-color: ${VALUT_TOOLTIP_BG} transparent transparent transparent;
    border-width: 6px 6px 0 6px;
    top: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  &.tight {
    transform: translate(-50%, calc(-100% + 12px));
  }

  &.valut-tooltip {
    background-color: ${VALUT_TOOLTIP_BG};
    border-color: ${VALUT_TOOLTIP_BORDER};
    color: ${VALUT_TOOLTIP_FG};
  }
`;
